const LineSvg = ({ classes }: { classes?: string }) => {
  return (
    <svg className={`h-px w-full ${classes ?? ''}`}>
      <line x1="0" y1="0" x2="100%" y2="100%" className="stroke-specialGray-012 stroke-1" />
    </svg>
  );
};

export default LineSvg;
